// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * fix-sprint-20261016-2029 F2 — the header a client sets on a request it
 * issues on a timer rather than on a person's action (the notification bell's
 * 30-second poll, a long-running job's status poll).
 *
 * `authenticate` checks the session family's idle clock on such a request
 * without renewing it. Before this, the bell's poll renewed the clock every 30
 * seconds on every admin page, so an unattended open tab was never
 * idle-expired and stayed usable until the absolute access expiry.
 *
 * The value is `'1'`. A request carrying any other value, or none, counts as
 * activity.
 */
export const BACKGROUND_REQUEST_HEADER = 'X-Background-Request';
//# sourceMappingURL=background-request.js.map